import Auth from "../models/Auth";

const AuthStore = Auth.create();

export default AuthStore;
